import { atom } from "jotai";

export const tipoPlanillaAtom = atom([]);